import React from 'react';

// Used in combination with Tab.Group under Tab.List.
// TODO: outline as a full tab group component
export function TealTab({
    selected,
    text,
    count,
    highlightCount = false,
    children,
}: {
    selected: boolean;
    text: string;
    count?: number;
    highlightCount?: boolean;
    children?: React.ReactNode;
}) {
    return (
        <div className="relative pb-1 md:pb-[18px] mr-6 focus:outline-none">
            <p
                className={`${
                    selected ? 'text-teal-600' : 'text-gray-400'
                } h-full relative px-2 flex gap-x-2 pb-1 text-sm font-[500]`}
            >
                {text}
                {children}
                {!!count && (
                    <span
                        className={`rounded-full text-sm h-[20px] min-w-[24px] flex items-center justify-center ${
                            highlightCount
                                ? 'bg-teal-600 text-white'
                                : selected
                                ? 'bg-teal-100'
                                : 'bg-gray-100'
                        }`}
                    >
                        {count}
                    </span>
                )}
            </p>
            {selected && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-teal-600" />}
        </div>
    );
}
